import type { ComponentProps } from "react";
import { Slot } from "radix-ui";
import { tv } from "tailwind-variants";
import type { VariantProps } from "tailwind-variants";

import { badgeVariants } from "@/shared/ui";

const chipVariants = tv({
  extend: badgeVariants,
  base: "cursor-pointer",
});

type ChipProps = ComponentProps<"button"> &
  VariantProps<typeof chipVariants> & {
    asChild?: boolean;
  };

export const Chip = ({
  className,
  asChild,
  size,
  color,
  outline,
  ...props
}: ChipProps) => {
  const Component = asChild ? Slot.Root : "button";

  return (
    <Component
      className={chipVariants({
        size,
        className,
        color,
        outline,
      })}
      {...props}
    />
  );
};
